export const hexToRgb = (hex: string) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return (
    result && {
      red: parseInt(result[1], 16),
      green: parseInt(result[2], 16),
      blue: parseInt(result[3], 16),
    }
  )
}

export const pickTextColor = (color: string, dark = '#000', light = '#fff') => {
  const { red = 0, green = 0, blue = 0 } = hexToRgb(color) || {}
  const brightness = red * 0.299 + green * 0.587 + blue * 0.114
  return brightness > 186 ? dark : light
}
